/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Validator } from '@squiz/dxp-console-support';

/**
 * Validates a value against a regular expression for Setting Key.
 * Only letters, numbers, dashes and underscores are valid.
 * Also must not contain only numbers.
 */
export class SettingKeyValidator<R> extends Validator<string, R> {
  public doValidate(value: string): boolean {
    const validCharacters = /^[-_.#A-z0-9]+$/g.test(String(value).trim());
    const isNumber = /^\d+$/.test(String(value).trim());
    return validCharacters && !isNumber;
  }
}
